import { createGlobalStyle } from 'styled-components'

export const MemberGlobalStyles = createGlobalStyle`
  body {
    font-family: 'Noto Sans JP', 'Open Sans', sans-serif;
    color: ${props => props.theme.members.colors.black._100};
  }
`
